import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCardImage = (props: any) => {
    const {
        block: { data },
    } = props;
    return (
        <BlockCard {...props}>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <img src={data.image} style={{ height: "30px" }} />
            </div>
        </BlockCard>
    );
};
export default renderCardImage;
